import { FC } from 'react'
import { IonRouterLink } from '@ionic/react'

import { UserName } from '@components/atoms/UserName'
import { FollowButton } from '@components/molecules/FollowButton'
import { ListItem } from '@components/molecules/ListItem'

import { IUser } from '@services/findUsers'

export interface IUsersListItemProps {
  item: IUser
  linkToMessages?: boolean
}

export const UsersListItem: FC<IUsersListItemProps> = ({
  item,
  linkToMessages,
}) => {
  if (linkToMessages) {
    return (
      <div
        key={item.id}
        className="w-full flex flex-wrap items-center justify-between pr-2"
      >
        <IonRouterLink className="w-full" routerLink={`/messages/${item.id}`}>
          <ListItem item={item}>
            <UserName
              className="block font-medium text-sm"
              name={item.username}
            />
          </ListItem>
        </IonRouterLink>
      </div>
    )
  }

  return (
    <ListItem key={item.id} item={item}>
      <div className="w-full flex flex-wrap items-center justify-between pr-2">
        <IonRouterLink
          className="max-w-[60%]"
          routerLink={`/profile/${item.id}`}
        >
          <UserName
            className="block font-medium text-sm"
            name={item.username}
          />
          <span className="text-xs">{item.displayName}</span>
        </IonRouterLink>
        <FollowButton
          userId={item.id}
          followStatus={item.followStatus}
          size="small"
          username={item.username}
        />
      </div>
    </ListItem>
  )
}
